/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPool} from '../api'

export const useMutationCreatePool = createReactQueryMutationHook('createPool', createPool)
